import ExpandedContent from './expanded-content';

export default ExpandedContent;
export { ExpandedContent };